import { computed } from 'vue';
import { useStore } from "vuex";
import yup from '@component_path/inquiry_form_common_module/customValidation';

export const useFirstNameField = (required, messages = {}) => {
  const fieldName = computed(() => 'first_name');
  const validator = yup.string()
    .max(30, messages['max'] || '名は30文字以内にしてください')
    .requirement(required, messages['requirement'] || '名は必須項目です');

  return { validator, fieldName }
}

export const useFirstNameStore = () => {
  const store = useStore();
  const firstName = computed(() => store.state.formData.first_name);
  const dispatcher = computed(() => 'formData/setFirstName');

  return { firstName, dispatcher }
}